import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as Go } from '../../../../assets/icons/icon-05.svg'; // icon-01
import { ReactComponent as Contact } from '../../../../assets/icons/icon-02.svg';
import { ReactComponent as Bb } from '../../../../assets/icons/icon-03.svg';
import { ReactComponent as Global2 } from '../../../../assets/icons/icon-04.svg';
import useGtmSender from '../../../../hooks/useGtmSender';

const useTopRightGroup = (
    setCanCancel: any,
    setContactDialog: any,
    hallwayToLoby: any,
    canvasStatus: boolean
) => {
    const { t, i18n } = useTranslation();
    const [rightTopDialog, setRightTopDialog] = useState(false);
    const gtmSender = useGtmSender({} as any);

    const lang = i18n.language;


    // 根據頁面狀態決定 GTM 事件前綴
    const getGtmPrefix = () => {
        return canvasStatus ? "新版-主軸榮耀" : "新版-首頁";
    };

    const handleGtmClick = (eventName: string) => {
        gtmSender({
            event: `${getGtmPrefix()}_${eventName}`
        });
    };

    const handleChangeLang = (lang: string) => {
        i18n.changeLanguage(lang);
    };

    const mobileDialogItemArr = [
        {
            icon: <Go />,
            content: t('header-index'),
            function: () => {
                handleGtmClick('返回首頁');
                hallwayToLoby(); 
                // 1秒後重整
                setTimeout(() => {
                    window.location.reload();
                }, 1000); //1秒種的動畫時間
            }
        },
        {
            icon: <Contact />,
            content: t('header-contact'),
            function: () => {
                handleGtmClick('聯絡我們');
                setContactDialog(true);
                setTimeout(() => {
                    setCanCancel(true);
                }, 1000);
            }
        },
        {
            icon: <Bb />,
            content: t('header-news'),
            function: () => {
                handleGtmClick('新聞動態');
                window.location.href = `/bbin/${lang}/News`;
            }
        },
        {
            icon: <Global2 />,
            content: 'CN / EN',
            function: () => {
                if (lang === 'cn') {
                    handleGtmClick('語系切換_EN');
                    handleChangeLang('en');
                } else {
                    handleGtmClick('語系切換_CN');
                    handleChangeLang('cn');
                }
            }
        }
    ];

    return {
        mobileDialogItemArr,
        handleChangeLang,
        lang,
        rightTopDialog,
        setRightTopDialog
    };
};

export default useTopRightGroup;
